import { get } from 'lodash';
import Icon from '../../components/icons';
import { publicAssetsPrefix } from '../../../../../configuration';

const trophyIcon = Icon({
  type: 'trophy',
  color: 'rgb(245, 212, 85)',
  size: 16,
});

class UnlockSurveyScreen {
  constructor() {
    this.getText = Pollfish.ui.getText;
  }

  renderHeader = () => {
    const { getText } = this;
    let title = getText('surveyPrompt', Pollfish.helper.surveyLOI);
    title = Pollfish.helper.is3rdParty()
      ? title.replace(/<span.*<\/span>/g, '')
      : title;
    return title;
  };

  renderImg = () => {
    const type = 'non-incentive';

    const imgEl = `
      <div class="card__image card__image--${type}">
        <div class="card__image-svg card__image-svg--${type}"></div>
      </div>
    `;

    return imgEl;
  };

  renderAcceptanceInfo = () => {
    const { getText } = this;
    const content = `
      <p class="text-xs text-grey unlock-screen--acceptance-info">
        ${getText('by_accepting_this_survey')}
      </p>
    `;

    return content;
  };

  renderWithdrawConsent = () => {
    let content = '';
    const { getText } = this;
    if (Pollfish.helper.hasAcceptedTerms()) {
      content = `
        <span class="horizontal-separator">/</span>
        <a href="#" class="js-withdraw-consent link-theme-hover">${getText(
          'withdraw_consent',
        )}</a>
      `;
    }

    return content;
  };

  renderTerms = () => {
    const { getText } = this;
    const text = getText('by_taking_survey');
    return `${text} <a href="#" class="js-terms link-theme-hover">${getText(
      'notify_terms',
    )}</a>`;
  };

  renderRewards = () => {
    const { reward_settings_enabled: rewardsEnabled } = Pollfish.helper.json;
    const { reward_name: rewardName, reward_value: rewardValue } = get(
      Pollfish,
      'helper.json.tag_survey',
      {},
    );

    // we always show LOI even if no rewards are enabled
    if (!rewardsEnabled || !rewardName || !rewardValue) {
      return '';
    }

    return `
      <div>
        <p class="margin-reset flex flex-align-items--center flex-1 flex-justify--center">
          <span class="line-height-reset">${trophyIcon}</span>
          <span style="margin-left: 3px" class="font-bold">${rewardValue}</span>
          <span class="margin-xxs-left">${rewardName}</span>
        </p>
      </div>
    `;
  };

  render() {
    const { getText } = this;
    const title = getText('offerwall.unlock_screen.title') || 'Unlock surveys';
    const subtitle =
      getText('offerwall.unlock_screen.subtitle') ||
      'by completing your profile';
    const getStarted =
      getText('offerwall.unlock_screen.btn_text') || 'Get started';
    const img = `${publicAssetsPrefix}/img/locked.png`;
    return `
      <div class="unlock-screen">
        <div class="text-align-center">
          <div class="margin-xl unlock-screen--title">
            <h1 class="margin-reset">${title}</h1>
            <p class="margin-reset">${subtitle}</p>
          </div>
          <div>
            <img src="${img}" alt="${title}">
          </div>
        </div>
        <div class="margin-md-top margin-md-btm">
          ${this.renderRewards()}
        </div>
        <div class="footer">
          <a href="#" class="btn btn-primary margin-lg-btm js-get-started-btn" data-page="unlock-screen">
            ${getStarted}
          </a>
          <p class="text-sm text-grey footer__terms">
            ${this.renderTerms()}
            ${this.renderWithdrawConsent()}
            ${this.renderAcceptanceInfo()}
          </p>
        </div>
      </div>`;
  }
}

export default UnlockSurveyScreen;
